var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.52 396c-20.127 0-28.581-7.794-31.439-20.549-2.733-12.2-7.383-32.951-7.383-32.951h-67.397s1.305 53.5-18.822 53.5c0 0-16.8 15 58.52 15s66.521-15 66.521-15z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.363 418.5c0 4.142-3.358 7.5-7.5 7.5h-185.726c-4.142 0-7.5-3.358-7.5-7.5v-7.5c0-8.284 6.716-15 15-15h170.727c8.284 0 15 6.716 15 15v7.5z",
    fill: "#b9c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.5 88.848 208.5 21.108 218.5-22.956v-16c0-8.25-6.75-15-15-15h-402z",
    fill: "#b9c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.5 56h-5c-8.25 0-15 6.75-15 15v16l20 10z",
    fill: "#909ba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 312.044-198.186 21.998c1.416 6.804-.314 20.758-.314 20.758l417-8.8v-10z",
    fill: "#b9c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.881 334.042-156.381 1.958v15c0 8.25 6.75 15 15 15h407c8.25 0 15-6.75 15-15v-5h-280.619z",
    fill: "#909ba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.5 331c0 1.754 139.44 3.432 140 5h287v-249h-417z",
    fill: "#f5fcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.5 301h-110v-214h-20v249h150v-15c0-11-9-20-20-20z",
    fill: "#d3effd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.107 321h-14.607l-90 10-90-10h-10l-10 125 229.607-10v-100c0-8.25-6.75-15-15-15z",
    fill: "#ff8086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 425.294v-104.294h-5c-8.25 0-15 6.75-15 15v105c0 8.25 6.75 15 15 15h15l90-10 90 10h14.607c8.25 0 15-6.75 15-15v-5h-208.901c-5.888 0-10.706-4.818-10.706-10.706z",
    fill: "#d16161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.5 436-90 10-90-10v-115h180z",
    fill: "#f5fcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.969 203.253-79.862-51.339-10 112.451c0 4.137 4.576 6.635 8.056 4.398l86.146-58.95c-.44-2.561-1.876-4.976-4.34-6.56z",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.107 254.365v-102.451l-4.894-3.146c-6.525-4.194-15.106.49-15.106 8.247v108.97c0 7.757 8.581 12.441 15.106 8.247l84.756-54.485c3.539-2.275 4.974-6.256 4.341-9.934l-76.146 48.95c-3.481 2.238-8.057-.261-8.057-4.398z",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.49 360.167-10 53.639c0 2.449 2.709 3.928 4.77 2.604l43.461-31.51c-.261-.264-.55-.51-.881-.723z",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.49 403.806v-43.639l-7.081-4.552c-3.42-2.199-7.919.257-7.919 4.323v57.124c0 4.066 4.498 6.522 7.919 4.323l44.431-28.562c2.816-1.81 3.104-5.679.881-7.923l-33.461 21.51c-2.061 1.324-4.77-.155-4.77-2.604z",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.5 436h180v20h-180z",
    fill: "#d3effd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232.106 463.5h-209.606c-12.406 0-22.5-10.094-22.5-22.5v-105c0-12.406 10.094-22.5 22.5-22.5h37.5v-242.5c0-12.406 10.094-22.5 22.5-22.5h307.78c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5h-307.78c-4.136 0-7.5 3.364-7.5 7.5v8.5h422v-8.5c0-4.136-3.364-7.5-7.5-7.5h-69.22c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h69.22c12.406 0 22.5 10.094 22.5 22.5v280c0 12.406-10.094 22.5-22.5 22.5h-165.17l.07.313c1.592 7.104 4.9 14.687 24.119 14.687 4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5h-93.913v15h124.257v-7.5c0-2.852-1.584-5.421-4.134-6.706-3.699-1.864-5.187-6.374-3.322-10.072 1.865-3.699 6.377-5.188 10.072-3.322 7.639 3.85 12.384 11.552 12.384 20.101v7.5c0 8.271-6.729 15-15 15h-124.257v7.5c0 12.405-10.093 22.499-22.5 22.499zm-7.106-15h7.106c4.136 0 7.5-3.364 7.5-7.5v-105c0-4.136-3.364-7.5-7.5-7.5h-7.106zm-180 0h165v-120h-165zm-22.5-120c-4.136 0-7.5 3.364-7.5 7.5v105c0 4.136 3.364 7.5 7.5 7.5h7.5v-120zm232.106 60h59.734c-2.079-3.272-3.607-7.077-4.578-11.409l-.805-3.591h-54.352v15zm0-30h234.894c4.136 0 7.5-3.364 7.5-7.5v-7.5h-219.894c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h219.894v-234h-422v219h157.106c12.406 0 22.5 10.094 22.5 22.5zm-138.143 69.195c-3.892 2.501-8.831 2.677-12.89.46-4.06-2.217-6.582-6.467-6.582-11.093v-57.125c0-4.626 2.522-8.876 6.582-11.093 4.061-2.218 9-2.042 12.892.46l44.432 28.563c3.635 2.337 5.804 6.312 5.804 10.632s-2.169 8.295-5.803 10.632c0 0-44.433 28.563-44.433 28.563zm-4.055-6.309h.01zm-.418-57.124v48.477l37.705-24.238zm145.277-83.721c-5.327 3.424-12.09 3.666-17.649.632-5.559-3.035-9.012-8.854-9.012-15.188v-108.97c0-6.333 3.453-12.152 9.012-15.188 5.56-3.035 12.321-2.793 17.65.632l84.756 54.485c4.976 3.199 7.946 8.641 7.946 14.556s-2.971 11.356-7.946 14.556zm-9.341-125.845c-.474 0-.868.159-1.119.296-.448.245-1.2.833-1.2 2.022v108.971c0 1.189.752 1.777 1.2 2.022.448.244 1.351.56 2.351-.085l84.756-54.484c.921-.592 1.058-1.469 1.058-1.938s-.137-1.347-1.058-1.938l-84.756-54.485c-.44-.283-.861-.381-1.232-.381z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.22251f052870caba73757c6901afbdee.svg";
export { ForwardRef as ReactComponent };